import { Directive } from '@angular/core';

@Directive({
    selector: '[qpxDialogSubtitle]',
})
export class DialogSubtitle {}
